import { render } from "./FooterBar.vue?vue&type=template&id=63e4afbc"
import script from "./FooterBar.vue?vue&type=script&lang=js"
export * from "./FooterBar.vue?vue&type=script&lang=js"

import "./FooterBar.vue?vue&type=style&index=0&id=63e4afbc&lang=scss"

import exportComponent from "/Users/wang/work/soulex/nebula-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__